module.exports = __webpack_public_path__ + "static/media/search-gray.57be6d03.svg";